export const ACTIVE = 'active'
export const INACTIVE = 'inactive'

export const FILTER_NAME = 'sales_overview'
